/*
 * @Author: your name
 * @Date: 2020-09-14 13:47:18
 * @LastEditTime: 2021-11-25 00:19:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factorydata/src/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import index from './module/index/index'
import demand from './module/demand/index'
import article from './module/article/index'
import common from './module/common/index'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    common,
    index,
    article,
    demand
  },
  strict: debug
})
